<div class="changelog-container">
    @if (changelogConfig(); as config) {
        <div class="changelog-header">
            <p>{{ config.summary }}</p>
        </div>

        <accordion>
            @for (entry of changelogs(); track entry.version; let isFirst = $first) {
                <accordion-group class="changelog-entry" [isOpen]="isFirst" #myGroup>
                    <button
                        class="btn btn-link btn-block justify-content-between d-flex w-100 shadow-none"
                        accordion-heading
                        type="button"
                    >
                        <div class="d-flex flex-row gap-2 overflow-hidden">
                            <fa-icon [icon]="myGroup?.isOpen ? iconDown : iconRight" class="w-3"></fa-icon>
                            <span class="changelog-entry__version">{{ entry.version }}</span>
                            @if (entry.summary.length > 0) {
                                <span class="changelog-entry__summary overflow-hidden text-nowrap">
                                    {{ entry.summary[0] }}
                                </span>
                            }
                        </div>
                    </button>
                    @for (summary of entry.summary; track summary) {
                        <p>{{ summary }}</p>
                    }
                    @for (detail of entry.changes | keyvalue; track detail.key) {
                        <div class="changelog-entry__section">
                            <h4>{{ typeHeadline(detail.key) }}</h4>
                            <ul class="changelog-entry__details">
                                @for (item of detail.value; track $index) {
                                    <li>{{ item }}</li>
                                }
                            </ul>
                        </div>
                    }
                </accordion-group>
            }
        </accordion>
    }
</div>
